import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class OfficeequipmentService {

  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/OfficeEquipment/';

  insertequipment(data: any) {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl + 'Insertequipment', data)
  }

  getequipment(id) {
    debugger
    return this.http.get(this.apiUrl + 'getequipment?id='+id)
  }

  getequipmentLY(id) {
    debugger
    return this.http.get(this.apiUrl + 'getequipmentLY?id=' + id)
  }
}
